/** axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
import store from '@/store' // 引入store
import baseURL from './config' // api地址

// 假设你使用的是 Element UI 的 Message 组件，或者自定义的 message 提示
import { Message } from 'element-ui' // 如果使用其他 UI 框架，请相应替换

axios.defaults.baseURL = baseURL
axios.defaults.timeout = 1000 * 30

// 用于防止重复提示的标记
const shownMessages = new Map()

// 显示错误消息
function showMessage(msg, type = 'error', duration = 3000) {
  if (!shownMessages.has(msg)) {
    shownMessages.set(msg, Date.now())
    Message({ message: msg, type, duration })

    // 一段时间后清除标记，允许相同消息再次显示
    setTimeout(() => {
      const timestamp = shownMessages.get(msg)
      if (timestamp && Date.now() - timestamp >= duration) {
        shownMessages.delete(msg)
      }
    }, duration + 1000)
  }
}

// 清理过期的消息标记
function cleanExpiredMessages() {
  const now = Date.now()
  for (const [msg, timestamp] of shownMessages.entries()) {
    if (now - timestamp > 4000) {
      // 4秒前的消息视为过期
      shownMessages.delete(msg)
    }
  }
}

axios.interceptors.response.use(
  (res) => {
    cleanExpiredMessages() // 清理过期标记

    const {
      data: { code = 200, msg }
    } = res
    // console.log(res)
    if (res.status === 200) {
      if (code === 200) {
        return res.data
      } else if (code === 401) {
        return res.data
      } else if (code === 403) {
        return res.data
      } else if (code === 500) {
        return res.data
      } else if (code !== 200) {
        return res.data
      }
    }
    showMessage('请求失败', 'error')
    return res.data
  },
  (error) => {
    cleanExpiredMessages() // 清理过期标记

    // 响应错误 处理
    if (error.response) {
      const { config, status, data } = error.response
      const errorMsg = `接口：${config.url},状态码:${status}, 消息：${data.msg || ''}`
      console.log(errorMsg)

      //获取硬盘序列号，不提示
      if (config.url === '/api') {
        return error.response
      }

      // 使用弱提示显示错误信息
      showMessage(data.msg || '网络请求错误', 'error')
      // 返回错误数据，避免在调用处再次处理
      return {
        code: status,
        msg: data.msg || '网络请求错误',
        data: null
      }
    } else {
      showMessage(error.message || '网络连接异常', 'error')
      return {
        code: -1,
        msg: error.message || '网络连接异常',
        data: null
      }
    }
  }
)

export default axios
